import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import { createUseStyles } from 'react-jss'
import {
  CustomerAddress,
  DocumentDate,
  Footer,
  Header,
  Subject,
  TableBody,
  TableHeader,
  theme
} from '../../document/Document'
import { baseDocument } from '../../../utils/constants/misc'

const useStyles = createUseStyles(theme)

const CreditNote = ({
  document_param: creditNote,
  company_param: company,
  logo_param: logo,
  settings_param: settings
}) => {
  const customer = creditNote.customer
  const classes = useStyles()

  const References = () => {
    if (creditNote) {
      return (
        <>
          <Box className={classes.rightContainer}>
            <Typography className={classes.boldWithSpace}>Référence avoir</Typography>
            <Typography className={classes.address}>{creditNote.creditNote_number}</Typography>
          </Box>
          {creditNote.quote_id !== null && creditNote.quote !== undefined && (
            <Box className={classes.rightContainerNoMT}>
              <Typography className={classes.boldWithSpace}>Référence devis</Typography>
              <Typography className={classes.address}>{creditNote.quote.quote_number}</Typography>
            </Box>
          )}
        </>
      )
    }
  }

  const CreditNotePayment = () => {
    if (customer && settings) {
      return (
        <Box className={classes.mt}>
          <Typography className={classes.conditions}>
            {customer.customer_type === 2
              ? `Règlement par : ${settings.creditNote_methods.replaceAll(',', ', ')}`
              : `Règlement par : ${settings.creditNote_methods_pro.replaceAll(',', ', ')}`}
          </Typography>
        </Box>
      )
    }
  }

  return (
    <Paper className={classes.paper}>
      <Box className={classes.page}>
        <Header classes={classes} documentTitle={'AVOIR'} logo={logo} />
        <References />
        <DocumentDate date={creditNote.creditNote_date} classes={classes} />
        <CustomerAddress customer={customer} company={company} classes={classes} />
        <Subject document={creditNote} classes={classes} />
        <TableHeader headers={baseDocument} classes={classes} />
        <TableBody
          headers={baseDocument}
          lines={creditNote.lines}
          total={creditNote.total_amount_net}
          classes={classes}
        />
        <CreditNotePayment />
        <Footer company={company} classes={classes} />
      </Box>
    </Paper>
  )
}

export default CreditNote
